import { appendQueryParams } from '../../routing/utils/url';
import { createHttpParams } from '../../core/utils/request';
import { User } from '../../core/interfaces/user';

export function appendTrackingParams(path: string, section: string, user: User, properties?: { [key: string]: any }) {
  const params = createHttpParams(properties || {});
  params['ui_section'] = section;
  if (user?.email) {
    params['app_user'] = user.email;
  }
  return appendQueryParams(path, new URLSearchParams(params).toString());
}
